import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from '../ui/button';
import { products } from '../../data/mock';

const ProductsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#242726]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <span className="caption text-[#c4291c] mb-4 block">Nos produits</span>
            <h1 className="heading-1 text-white mb-6">
              Une gamme complète de solutions béton
            </h1>
            <p className="body-large text-white/70">
              PREBATI propose une large gamme de produits en béton, du plancher précontraint aux parpaings, pour répondre à tous vos besoins de construction.
            </p>
          </div>
        </div>
      </section>

      {/* Products List */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="space-y-24">
            {products.map((product, index) => (
              <div
                key={product.id}
                id={product.id}
                className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
              >
                {/* Image */}
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <span className="caption text-[#c4291c] mb-4 block">
                    Produit {String(index + 1).padStart(2, '0')}
                  </span>
                  <h2 className="heading-2 text-white mb-4">{product.title}</h2>
                  <p className="body-large text-white/70 mb-6">{product.description}</p>

                  {/* Details */}
                  <div className="mb-6">
                    <h4 className="text-white font-semibold mb-3">Caractéristiques</h4>
                    <ul className="space-y-2">
                      {product.details.map((detail, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <Check className="w-5 h-5 text-[#c4291c] mt-0.5 flex-shrink-0" />
                          <span className="text-white/70 body-medium">{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Use Cases */}
                  <div className="mb-6">
                    <h4 className="text-white font-semibold mb-3">Applications</h4>
                    <div className="flex flex-wrap gap-2">
                      {product.useCases.map((useCase, i) => (
                        <span
                          key={i}
                          className="px-3 py-1.5 bg-[#2a2d2c] border border-white/10 rounded-full text-white/70 text-sm"
                        >
                          {useCase}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Advantages */}
                  <div className="mb-8">
                    <h4 className="text-white font-semibold mb-3">Avantages</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {product.advantages.map((advantage, i) => (
                        <div key={i} className="flex items-center gap-2">
                          <div className="w-2 h-2 rounded-full bg-[#c4291c]" />
                          <span className="text-white/70 body-small">{advantage}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
                    <Button className="btn-primary">
                      Demander un devis
                      <ArrowRight className="w-4 h-4" />
                    </Button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#c4291c]">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="heading-2 text-white mb-6">
              Besoin d'un produit spécifique ?
            </h2>
            <p className="body-large text-white/90 mb-10">
              Notre équipe est à votre disposition pour étudier vos besoins et vous proposer la meilleure solution.
            </p>
            <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
              <Button className="bg-white text-[#c4291c] hover:bg-white/90 btn-primary border-0">
                Contactez-nous
                <ArrowRight className="w-4 h-4" />
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
